import {XmlTagInfo, XmlTagProvider, XmlTagScope} from './xmlTagProvider';

interface XmlParsedNode  {
    tag: string,
    attributes: {[name:string]:string},
    children: any[],
    value?: string,
}


// xml parser with custom tag handlers
// tags - tag handler provider
// scope - model passed to every tag function, can be anything
export default class Xml {

	scope?: XmlTagScope;
	tags: XmlTagProvider;

	constructor(tags: XmlTagProvider, scope?: XmlTagScope) {
		this.scope = scope;
		this.tags = tags; // tags should be set via constructor
	}

	process(xmlString: string) {
		const d = this.parseString(xmlString);
		return this.processNode(d.documentElement, []);
	}

	processNode(node:any, parentPath: string[]): any {
		const attributes: {[name:string]:any} = {};
        const currentPath = (parentPath || []).concat(node.nodeName);
		let value: string|undefined = node.value;
        let children: any[] = [];

		if(node.nodeName === "#text" || node.nodeName === "#cdata-section"){
			const text = node.nodeValue.trim();
			if(text === ""){
				return null;
			} else {
				return node.nodeValue;
			}
		}

		if(node.childNodes){
			for(let i=0; i < node.childNodes.length; i++) {
				const child = node.childNodes.item(i);
				const processedChild = this.processNode(child, currentPath);
				if(processedChild != null){
					children.push(processedChild);
				}
			}
		}

		if(node.attributes){
			for(let j=0; j < node.attributes.length; j++) {
				const attribute: {name: string, value: any} = node.attributes.item(j);
				attributes[attribute.name]=attribute.value;
			}
		}

		if(!value && children.length === 1 && typeof children[0] === 'string'){
			value = children[0];
			children = [];
		}

		const tagHandler = (this.tags && this.tags.get(currentPath)) ? this.tags.get(currentPath) : this.defaultTagHandler;
		return tagHandler({
			// @ts-ignore
            domNode: node,
			tag: node.nodeName,
			attributes: attributes,
			children: children,
			value: value,
			scope: this.scope
		});
	}

	parseString(xmlString: string): any {
		const w: any = window; // disable typechecking for ActiveX check
		if (typeof w.DOMParser !== "undefined") {
			return ( new w.DOMParser() ).parseFromString(xmlString, "text/xml");
		} else if (typeof w.ActiveXObject !== "undefined" &&
			new w.ActiveXObject("Microsoft.XMLDOM")) {
			const xmlDoc = new w.ActiveXObject("Microsoft.XMLDOM");
			xmlDoc.async = "false";
			xmlDoc.loadXML(xmlString);
			return xmlDoc;
		} else {
			throw new Error("No XML parser found");
		}
	}

	defaultTagHandler(node: XmlTagInfo): XmlParsedNode {
		const parsedNode: XmlParsedNode = {
			tag: node.tag,
			attributes: node.attributes,
			children: node.children,
		};
		if (node.value !== undefined) {
            parsedNode.value = node.value;
        }
        return parsedNode;
	}
}